import { useHistory } from "react-router-dom";
import { useMutation, useQueryClient } from 'react-query';

import { PATHS } from "@config/constants";
import { loginApi, getUserApi, registerApi, verifyOTPApi, getTurnRemainApi, registerPack, bidApi, changePasswordApi, updateInformationApi, getBidHistoryApi, requestOTP, viewInfoWinner, logoutApi, requestOtpPackage, verifyOtpPackage, detectPhoneApi, getPackageListApi, getListRankEventNewYear } from "@api/user";
import { saveUserInfo, setData, getData } from "@utils/localStorage";
import { queryKeyPotentialWinner } from "./product";
import { postPairingEventNewYearApi, postStartOpenEventNoel } from "@api/product";

export const queryKey = "userInfo";
export const queryKeyIsdn = "isdn";
export const queryKeyTurn = "remain_turn";
export const queryKeyBidHistory = "my_bid_history";
export const queryKeyPackageList = 'my_package_list';
export const queryPairing = "pairing";
export const queryOpenGift = "queryOpenGift";
export const queryListRankNewYear = "list_rank_new_year"

export const getUserQuery = () => ({
  queryKey: [queryKey],
  queryFn: getUserApi,
});

export const useLogin = () => {
  const queryClient = useQueryClient();
  const history = useHistory();

  return useMutation(loginApi, {
    onSuccess: data => {
      saveUserInfo(data); // do not save user to localStorage
      queryClient.setQueryData(queryKey, data);
      history.push(PATHS.BID_PAGE);
    },
    onError: (e) => {
      queryClient.invalidateQueries(queryKey);
    },
    onSettled: async () => {
      queryClient.invalidateQueries(queryKey);
    },
  });
}

export const getIsdnQuery = () => ({
  queryKey: [queryKeyIsdn],
  queryFn: () => Promise.resolve(getData(queryKeyIsdn)),
});

export const useRegister = () => {
  const history = useHistory();
  const queryClient = useQueryClient();

  return useMutation(registerApi, {
    onSuccess: (_, variables) => {
      setData(queryKeyIsdn, variables.isdn);
      queryClient.setQueryData(queryKeyIsdn, variables.isdn);
      history.push(PATHS.VERIFY_OTP_PAGE);
    },
    onSettled: async () => {
      queryClient.invalidateQueries(queryKeyIsdn);
    },
  });
}

export const useVerifyOTP = () => {
  const history = useHistory();
  const queryClient = useQueryClient();

  return useMutation(verifyOTPApi, {
    onSuccess: data => {
      saveUserInfo(data);
      queryClient.setQueryData(queryKey, data);
      history.push(PATHS.BID_PAGE);
    },
    onSettled: async () => {
      queryClient.invalidateQueries(queryKeyIsdn);
    },
  });
}

export const usePairingEventNewYear = () => {
    const queryClient = useQueryClient();

    return useMutation(postPairingEventNewYearApi, {
      onSuccess: (data) => {
        queryClient.setQueryData(queryPairing, data);
      },
      onSettled: async () => {
        queryClient.invalidateQueries(queryPairing);
      },
    });
}

export const useStartOpenEventNoel = () => {
  const queryClient = useQueryClient();

  return useMutation(postStartOpenEventNoel, {
    onSuccess: (data) => {
      queryClient.setQueryData(queryOpenGift, data);
    },
    onSettled: async () => {
      queryClient.invalidateQueries(queryOpenGift);
    },
  });
}

export const useRequestOTP = () => {
  const queryClient = useQueryClient();

  return useMutation(requestOTP, {
    onSuccess: (_, variables) => {
      setData(queryKeyIsdn, variables.isdn);
      queryClient.setQueryData(queryKeyIsdn, variables.isdn);
    },
    onSettled: async () => {
      queryClient.invalidateQueries(queryKeyIsdn);
    },
  });
}

export const useRequestOtpPackage = () => {
  const queryClient = useQueryClient();

  return useMutation(requestOtpPackage, {
    onSuccess: (_, variables) => {
      setData(queryKeyIsdn, variables.isdn);
      queryClient.setQueryData(queryKeyIsdn, variables.isdn);
    },
    onSettled: async () => {
      queryClient.invalidateQueries(queryKeyIsdn);
    },
  });
}

export const useVerifyOtpPackage = () => {
  const queryClient = useQueryClient();

  return useMutation(verifyOtpPackage, {
    onSuccess: (_, variables) => {
      setData(queryKeyIsdn, variables.isdn);
      queryClient.setQueryData(queryKeyIsdn, variables.isdn);
      queryClient.invalidateQueries(queryKeyTurn);
    },
    onSettled: async () => {
      queryClient.invalidateQueries(queryKeyIsdn);
    },
  });
}

export const getRemainTurnQuery = () => ({
  queryKey: [queryKeyTurn],
  queryFn: getTurnRemainApi,
});

export const getBidHistoryQuery = (page = 1, pageSize = 10) => ({
  queryKey: [queryKeyBidHistory, { page, pageSize }],
  queryFn: getBidHistoryApi,
});

export const useRegisterPack = () => {
  const queryClient = useQueryClient();

  return useMutation(registerPack, {
    onSuccess: () => {
      queryClient.invalidateQueries(queryKeyTurn);
    },
    onSettled: async () => {
      queryClient.invalidateQueries(queryKeyTurn);
    },
  });
}

export const useBid = () => {
  const queryClient = useQueryClient();

  return useMutation(bidApi, {
    onSuccess: () => {
      queryClient.invalidateQueries(queryKeyTurn);
      queryClient.invalidateQueries(queryKeyPotentialWinner);
    },
    onSettled: async () => {
      queryClient.invalidateQueries(queryKeyTurn);
    },
  });
}

export const useChangePassword = () => {
  return useMutation(changePasswordApi);
}

export const useUpdateInfo = () => {
  const queryClient = useQueryClient();

  return useMutation(updateInformationApi, {
    onSuccess: () => {
      queryClient.invalidateQueries(queryKey);
    },
    onSettled: async () => {
      queryClient.invalidateQueries(queryKey);
    },
  });
}

export const useLogout = () => {
  return useMutation(logoutApi);
}

export const useViewWinner = () => {
  return useMutation(viewInfoWinner);
}

export const useDetectPhone = () => {
  const queryClient = useQueryClient();
  return useMutation(detectPhoneApi, {
    onSuccess: data => {
      queryClient.setQueryData(queryKey, data);
    },
    onError: (e) => {
      queryClient.invalidateQueries(queryKey);
    },
    onSettled: async () => {
      queryClient.invalidateQueries(queryKey);
    },
  });
}

export const getPackageListQuery = (page = 1, pageSize = 10, status) => ({
  queryKey: [queryKeyPackageList, { page, pageSize, status }],
  queryFn: getPackageListApi,
});

export const getRankNewYear2024 = (page = 1, limit = 10, my_rank = 0) => ({
  queryKey: [queryListRankNewYear, { page, limit, my_rank }],
  queryFn: getListRankEventNewYear,
});
